import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import HouseIcon from '../images/cny-logo-nav.svg';
import ContactIcon from '../images/contact-icon.svg';
import AboutIcon from '../images/about-icon.svg';

const MobileNavBarTop = ({ toggleContact, toggleAbout }) => {
  const [navVisibility, setNavVisibility] = useState(true);
  const [previousScrollTop, setPreviousScrollTop] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollTop = window.scrollY;
      if (currentScrollTop < 50) {
        setNavVisibility(true);
      } else {
        const visible = previousScrollTop > currentScrollTop;
        setNavVisibility(visible);
      }
      setPreviousScrollTop(currentScrollTop);
    };
    window.addEventListener('scroll', handleScroll);
    setPreviousScrollTop(window.scrollY);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [previousScrollTop]);

  return (
    <div className={`mobile-nav-bar-top ${navVisibility ? 'show' : ''}`}>
      <div className="nav-links-left">
        <a href="#top">
          <img src={HouseIcon} alt="CNYCN logo" />
        </a>
      </div>
      <div className="nav-links-right">
        <a onClick={toggleAbout} href="#about" className="nav-link about">
          <img src={AboutIcon} alt="about icon" />
        </a>
        <a onClick={toggleContact} href="#contact">
          <img src={ContactIcon} alt="contact icon" />
        </a>
      </div>
    </div>
  );
};

MobileNavBarTop.propTypes = {
  toggleContact: PropTypes.func.isRequired,
  toggleAbout: PropTypes.func.isRequired
};

export default MobileNavBarTop;
